import { Action, createReducer, on } from '@ngrx/store';
import * as fromUWQuestionsActions from '../../store/uw-questions/uw-questions.actions';
import { initialState, UWQuestionsState } from './uw-questions.state';

const _uwQuestionsReducer = createReducer(
  initialState,
  on(
    fromUWQuestionsActions.updateUWQuestionsIsLoadingFromUWQuestionsSavingData,
    (state, { isLoading }) => ({ ...state, isLoading: isLoading })
  )
);

export function uwQuestionsReducer(
  state: UWQuestionsState | null,
  action: Action
) {
  return _uwQuestionsReducer(state, action);
}